import { render, staticRenderFns } from "./QuadrilateralViz.vue?vue&type=template&id=5079e26a&scoped=true"
import script from "./QuadrilateralViz.vue?vue&type=script&lang=js"
export * from "./QuadrilateralViz.vue?vue&type=script&lang=js"
import style0 from "./QuadrilateralViz.vue?vue&type=style&index=0&id=5079e26a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079e26a",
  null
  
)

export default component.exports